// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"636":"marketplace-page","974":"shared-marketplace-page"}[chunkId] + "." + {"636":"6427a644","974":"6427a644"}[chunkId] + ".chunk.css";
};